import { useContext } from 'react'
import { MySiteContext } from 'providers/mySiteProvider'

export const usePersistPagination = () => {
  const { pagination, setPagination } = useContext(MySiteContext)

  function selectPage(currentPage) {
    setPagination((s) => {
      return { ...s, currentPage }
    })
  }

  function nextPage() {
    if (pagination.currentPage === pagination.totalPages) {
      return
    }
    setPagination((s) => {
      return { ...s, currentPage: s.currentPage + 1 }
    })
  }

  function prevPage() {
    if (pagination.currentPage === 1) {
      return
    }

    setPagination((s) => {
      return { ...s, currentPage: s.currentPage - 1 }
    })
  }

  function nextSection() {
    setPagination((s) => {
      const step = 5
      const targetPage = s.currentPage + step
      const boundedPage = Math.min(targetPage, s.totalPages || targetPage)
      return { ...s, currentPage: boundedPage }
    })
  }

  function prevSection() {
    setPagination((s) => {
      const step = 5
      const targetPage = s.currentPage - step
      const boundedPage = Math.max(1, targetPage)
      return { ...s, currentPage: boundedPage }
    })
  }

  const changeResultsPerPage = (e) => {
    setPagination((s) => {
      return { ...s, resultsPerPage: e.value, currentPage: 1 }
    })
  }

  return { setPagination, selectPage, nextPage, prevPage, nextSection, prevSection, changeResultsPerPage }
}
